import { h } from 'vue';
import { message, Modal, Select } from 'ant-design-vue';
import { getDeclineReasonOptions } from '@/enums/declineReason';

/**
 * Спрашивает причину возврата планировки заказчику.
 *
 * Свободный ввод не предусмотрен: выбрать можно только то, что есть в списке.
 * Резолвится текстом причины для заказчика; если окно закрыли — не резолвится вовсе,
 * поэтому вызывающий код просто ничего не делает.
 *
 * @returns {Promise<string>}
 */
export default function confirmDeclineWithReason() {
  return new Promise((resolve) => {
    let reason = null;

    Modal.confirm({
      centered: true,
      title: 'Вы уверены, что хотите отклонить планировку?',
      content: h('div', { style: { marginTop: '0.75rem' } }, [
        h('div', { style: { marginBottom: '0.5rem' } }, 'Причина возврата заказчику'),
        h(Select, {
          options: getDeclineReasonOptions(),
          placeholder: 'Выберите причину',
          style: { width: '100%' },
          // Иначе выпадающий список уезжает под модальное окно.
          getPopupContainer: (trigger) => trigger.parentNode,
          'onUpdate:value': (value) => {
            reason = value;
          },
        }),
      ]),
      cancelText: 'Отмена',
      okText: 'Отклонить',
      okType: 'danger',
      onOk: () => {
        if (!reason) {
          message.error('Выберите причину возврата');

          // Отклонённый промис оставляет окно открытым.
          return Promise.reject(new Error('decline reason is required'));
        }

        resolve(reason);

        return Promise.resolve();
      },
    });
  });
}
